const hospitalTranslation = {
  mode: 'ko',
  menu: '병원',

  subscriptionManagementTitle: '병원 구독 관리',
  subscriptionMenu: '구독 관리',
  subscriptionColumnsDuration: '구독 기간 (일)',
  subscriptionColumnsStartDate: '유료화 시작일',
  subscriptionColumnsEndDate: '구독 종료일',
  subscriptionColumnsStatus: '구독 상태',
  subscriptionFilterLabel: '상태 필터',
  subscriptionFilterSubscribed: '구독',
  subscriptionFilterUnsubscribed: '미구독',
  subscriptionTagSubscribed: '구독 병원',
  subscriptionTagUnsubscribed: '미구독 병원',
  subscriptionTagTotal: '전체 병원',
  subscriptionSearchPlaceholder: '병원명 또는 시퀀스로 검색',
  subscriptionSearchResults: '검색 결과',
  subscriptionUpdateInvalid: '구독 기간은 1일 이상이어야 합니다.',
  subscriptionUpdateSuccess: '구독 기간이 성공적으로 업데이트되었습니다.',
  subscriptionUpdateFailure: '업데이트 실패',
  subscriptionUpdateError: '구독 기간 업데이트 중 오류가 발생했습니다.',
  subscriptionStartDateInvalid: '유효한 날짜를 입력해주세요',
  subscriptionStartDateUpdateSuccess: '유료화 시작일이 업데이트되었습니다',
  subscriptionStartDateUpdateFailure: '유료화 시작일 업데이트에 실패했습니다',
  subscriptionStartDateUpdateError: '유료화 시작일 업데이트 중 오류가 발생했습니다',
  subscriptionDurationTooltip: '최소 1일, 최대 3650일까지 입력 가능',
  subscriptionDurationMaxLabel: '최대 3650일',
  subscriptionDaysUnit: '{{value}}일',

  hospitalTableTitle: '병원 리스트',
  addHospital: '병원 추가',
  addHospitalRoom: '진료실 추가',
  addHospitalLogin: '계정 추가',
  seq: '번호',
  name: '이름',
  realName: '실제 병원명',
  regionAlias: '지역 별칭',
  doctorName: '담당의',
  hospitalName: '병원명',
  zipcode: '우편번호',
  address: '전체 주소',
  street: '상세 주소',
  lat: '위도',
  lng: '경도',
  city: '시/군/구',
  province: '시/도',
  telephone: '대표번호',
  deviceAlertPhone: '마미박스 이상 알림 전용 연락 번호(휴대전화 전용)',
  deviceAlertPhonePlaceholder: '010-0000-0000',
  deviceAlertPhoneInvalid: '휴대전화번호 또는 국제번호 형식으로 입력해 주세요.',
  description: '설명',
  homepage: '병원 홈페이지 주소',
  paidBarcodeDate: '유료화 시작일',
  viewable: '영상 & 초음파 보이기 상태 선택(선택시 보임)',
  recording: '초음파 영상',
  capture: '초음파 캡쳐',
  hospitalPermission: '병원 권한',
  hospitalStatus: '병원 상태',
  uploadVisibilitySettings: '업로드 표시 설정',
  nipt: 'NIPT',
  libre: 'LIBRE',
  qrPayment: 'QR 결제',
  isMaternity: '분만 병원',
  pinkBarcode: '핑크바코드 시작일',
  useNipt: 'NIPT 사용',
  useLibre: 'LIBRE 사용',
  useBabyMagic: '베이비 매직 사용',
  useQrPayment: 'QR 결제 사용',
  crystalReveal: 'CrystalReveal',
  crystalRevealMode: 'CrystalReveal 사용 모드',
  crystalRevealNone: '미사용',
  crystalRevealBasic: '기본 사용',
  crystalRevealFull: '전체 사용',
  activeFlag: '활성 여부',
  activeStatus: '활성상태',
  active: '활성',
  inactive: '비활성',
  activeHospital: '활성 병원',
  inactiveHospital: '비활성 병원',
  streamingStop: '스트리밍 중지',
  streamingStopped: '중지됨',
  streaming: '스트리밍',
  id: '아이디',
  password: '비밀번호',
  permission: '권한',

  statistics: '통계',
  dailyMonthlyStatistics: '일/월별 통계',
  dailyMonthlyUltrasoundStatistics: '일/월별 초음파 통계',
  dailyStatistics: '일별 통계',
  monthlyStatistics: '월별 통계',
  dailyBarcodeCount: '일별 바코드 수',
  dailyVideoLengthAvg: '일별 초음파 영상 길이 평균',
  monthlyBarcodeCount: '월별 바코드 수',
  monthlyVideoLengthAvg: '월별 초음파 영상 길이 평균',

  record: '기록',
  detailRecord: '상세 기록',

  videoPlay: '영상 재생',
  videoDetailSearch: '영상 상세검색',
  videoDownload: '다운로드',
  deviceList: '장비 열람',
  niptAdmin: 'NIPT 관리',
  libreAdmin: 'LIBRE 관리',
  telemedicineAdmin: '원격진료 관리',
  statsDisplay: '지표 관리',
  medicalRecordDisplay: '진료기록 관리',
  videoBlind: '영상 블라인드',

  saveInfo: '정보 저장',
  info: '기본 정보',
  hospitalInfo: '병원 정보',
  billingInfo: '과금 정보',
  hospitalRoomInfo: '진료실 정보',
  hospitalLoginInfo: '병원용 관리자 계정 정보',
  editHospitalInfo: '병원 정보 수정',
  noRawPassword: '평문 없음',
  passwordIssuedByEmail: '저장 후 임시 비밀번호가 메일로 발송됩니다.',

  loginWarningMessage: '이미 사용하는 아이디입니다.',
  idEmailFormatMessage: '아이디는 이메일 형식으로 입력해 주세요.',
  idEmailPlaceholder: 'example@hospital.com',
  loginErrorMessage: '수정에 실패하였습니다. 관리자에게 문의해 주세요.',
  loginEmailSuccessMessage: '계정이 생성되고 메일이 발송되었습니다.',
  loginEmailSuccessDescription: '병원 관리자에게 메일을 확인해 달라고 안내해 주세요.',
  loginEmailWarningMessage: '계정은 생성되었지만 메일 전송에 실패했습니다.',
  loginEmailWarningDescription: '병원 관리자에게 비밀번호를 별도로 안내해 주세요.',
  deleteHospitalRoomMessage: '진료실을 삭제하시겠습니까?',
  deleteLoginMessage: '계정을 삭제하시겠습니까?',

  // 팝업 대상 관리
  popupTargetManagement: '팝업 대상 관리',
  popupTargetManagementDesc: '팝업을 표시할 병원들을 관리합니다',
  hospitalList: '병원 관리',
  hospitalSeq: '병원 번호',
  popupTargetStatus: '팝업 대상 여부',
  isPopupTarget: '대상',
  notPopupTarget: '미대상',
  selectHospitalFirst: '병원을 먼저 선택해주세요',
  selectHospitalToAdd: '추가할 병원을 선택하세요',
  addTarget: '대상 추가',
  removeTarget: '대상 제거',
  totalTargets: '전체 대상',

  addTargetSuccess: '팝업 대상 병원이 추가되었습니다',
  removeTargetSuccess: '팝업 대상 병원이 제거되었습니다',
  removeTargetConfirm: '정말로 팝업 대상에서 제거하시겠습니까?',
  removeTargetDescription: '이 병원은 더 이상 팝업을 받지 않습니다',

  // 필터 및 통계
  filterByStatus: '상태별 필터',
  showAll: '전체',
  showTargets: '대상만',
  showNonTargets: '미대상만',
  targetCount: '대상 병원',
  totalCount: '전체 병원',
  searchHospitalPlaceholder: '병원명 또는 번호로 검색',
  searchResults: '검색 결과',

  popupContent: '팝업 내용',
  popupType: '팝업 유형',
  popupStatus: '상태',
  targetHospital: '대상 병원',
  allHospitals: '모든 병원',

  popupTitleRequired: '팝업 제목을 입력해주세요',
  popupContentRequired: '팝업 내용을 입력해주세요',
  popupTypeRequired: '팝업 유형을 선택해주세요',
  popupTitlePlaceholder: '팝업 제목 입력',
  popupContentPlaceholder: '팝업 내용 입력',
  selectPopupType: '팝업 유형 선택',
  selectTargetHospital: '대상 병원 선택',

  'popupType.notice': '공지사항',
  'popupType.event': '이벤트',
  'popupType.maintenance': '점검',

  // 상태 변경 시간
  lastStatusChangeTime: '최종 상태 변경 시간',
  activationStartTime: '활성 시작 시간',
  deactivationStartTime: '비활성 시작 시간',
};

export default hospitalTranslation;
